import React from "react"
import { SelectField, MenuItem } from "material-ui"
import * as utils from "../../../../helpers/utils"
import strings from "../../../../localization/strings"
import * as hierarchyHelper from "../../../../helpers/hierarchyHelper"
import AccountStore from "../../../../stores/AccountStore"
import ScheduleTemplateAndMasterScheduleChip from "./select_template_chip/ScheduleTemplateAndMasterScheduleChip"
import { IScheduleTemplate, IScheduleDocument } from "../../../../models"
import * as userHelper from "../../../../helpers/userHelper"
interface IProps {
    masterSchedule: boolean
    overrideHierarchy: boolean
    hierarchyId: string
    jobId: string
    selectedTemplate: IScheduleTemplate | IScheduleDocument
    handleSelect(selectedTemplate: IScheduleTemplate | IScheduleDocument)
}

const SelectTemplate: React.SFC<IProps> = (props: IProps) => {
    return props.masterSchedule ?
        <SelectField
            data-intercom-target={"SchdeuleTemplate-Select-ScheduleTemplate"}
            floatingLabelText={strings.Schedule_Template}
            style={{ marginRight: 100 }}
            value={props.selectedTemplate}
            onChange={(e, key, selectedTemplate) => props.handleSelect(selectedTemplate)}
        >
            {utils.sortAlphabetical(AccountStore.getCurrentAccount().ScheduleData.ScheduleTemplates, "Name")
                .filter(item =>
                    !item.Deleted &&
                    item.PatternTemplates.length !== 0 &&
                    (props.overrideHierarchy ?
                        userHelper.getSupervisorAccessHierarchyIds().includes(item.HierarchyId) :
                        hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, props.hierarchyId).includes(item.HierarchyId)
                    )
                )
                .map((item, index) =>
                    <MenuItem value={item} primaryText={item.Name} key={index} />
                )}
        </SelectField> :
        <ScheduleTemplateAndMasterScheduleChip
            overrideHierarchy={props.overrideHierarchy}
            hierarchyId={props.hierarchyId}
            jobId={props.jobId}
            selectedTemplate={props.selectedTemplate}
            handleSelectTemplate={props.handleSelect}
        />
}

export default SelectTemplate